<template>
	<div >
		<div class="p_m_b_20" v-for="(item,index) in 4" :key="index">
			 <el-radio v-model="radio" :label="index">备选项</el-radio>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			radio:0
		};
	},
	mounted() {},
	methods: {
	}
};
</script>

<style lang="scss" scoped>
	>>> .el-radio__input.is-checked .el-radio__inner {
		border-color: #00af63;
		background: #00af63;
	}
	>>> .el-radio__input.is-checked + .el-radio__label {
		color: #333333;
	}
	>>> .el-radio__inner {
		width: 20px;
		height: 20px;
	}
	>>> .el-radio__label {
		font-size: 18px;
	}
	>>> .el-radio__inner:hover {
		border-color: #999999;
	}
	>>> .el-radio__inner::after {
		width: 8px;
		height: 8px;
	}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/components/choice.vue